import React, { useState } from 'react';
import { TaskControlsAction, TaskStatus } from '../../types/tasks.types';
import { makeTaskLink } from '../../utils/linkbuilder';
import { ConfirmPane, ConfirmPaneLockScroll } from '../../components/confirmpane';

interface PropsType{
	usermail:string;
	taskStatus:TaskStatus;
	tasksList:string[];
	getTask:(taskTitle: string) => void;
	taskControlsClick:(taskAction: TaskControlsAction, taskTitle: string) => void;
}

const NOT_LOGGED_IN_MSG:React.ReactElement=<p className='teachers-statusmessage'>Not logged in</p>;
const INTRO_TEXT="Create a homework task that you can monitor.  This will create a link that you can share with your students.  When students open the link, they will be prompted to enter a name.  When they finish the game, their score will be recorded and all the records will be viewable here on this site.  Only you will be able to view this data.";
const CHINA_TEXT="Warning - Content and homework tasks may not be accessible for students in China.  The rest of the site and embedded pages should work.";

const TasksList = function(props: PropsType) {
	const [showConfirmPane, setShowConfirmPane] = useState(false);
	const [taskToDelete, setTaskToDelete] = useState('');

	const actionClick = (myAction: TaskControlsAction, taskTitle: string) => {
		if(myAction === TaskControlsAction.View) props.getTask(taskTitle);
		if(myAction === TaskControlsAction.Open) openTask(taskTitle);
		if(myAction === TaskControlsAction.Delete) deleteTask(taskTitle);
	}

	const openTask = function(taskTitle: string) {
		const DEFAULT_PAGE = 'vocab';
		const win = window.open(makeTaskLink(DEFAULT_PAGE, props.usermail, taskTitle), '_blank');
		if (win != null) win.focus();
	}

	const deleteTask = function(taskTitle: string) {
		setTaskToDelete(taskTitle);
		setShowConfirmPane(true);
		ConfirmPaneLockScroll(true);
	}

	const deleteConfirmPaneClick = function(isConfirmed: boolean) {
		ConfirmPaneLockScroll(false);
		setShowConfirmPane(false);
		if(isConfirmed) props.taskControlsClick(TaskControlsAction.Delete, taskToDelete);
	}

	const createTaskClick = () => {
		props.getTask('');
	}

	if(props.usermail === '') return NOT_LOGGED_IN_MSG;

	let myTasks = props.tasksList.map((taskTitle, index) => {
		let displayTitle = taskTitle.replace(/_/g, ' ');
		return (
			<li className='teachers-task-listitem teachers-taskslist-fullitem' key={displayTitle+'-'+index}>
				<span className='teachers-listitem-name'>{displayTitle}</span>
				<div className='teachers-listitem-buttons'>
					<button className='teachers-listitem-button teachers-listitem-button-view' onClick={() => {actionClick(TaskControlsAction.View, taskTitle);}}>View Info</button>
					{/* <button className='teachers-listitem-button teachers-listitem-button-open' onClick={() => {actionClick(TaskControlsAction.Open, taskTitle);}}>Open Page</button> */}
					<button className='teachers-listitem-button teachers-listitem-button-delete' onClick={() => {actionClick(TaskControlsAction.Delete, taskTitle);}}>Delete</button>
				</div>
			</li>
		);
	});

	let mySimpleButtons = props.tasksList.map((taskTitle, index) => {
		let displayTitle = taskTitle.replace(/_/g, ' ');
		return (
			<button
				key={taskTitle+'-simple-'+index}
				className='teachers-button teachers-button-light teachers-taskslist-simplebutton'
				onClick={() => {actionClick(TaskControlsAction.View, taskTitle);}}>
				{displayTitle}
			</button>
		);
	});

	if(props.taskStatus===TaskStatus.DeleteTask){
		return <DeletingMsg />
	}else{
		return (
			<div id='teachers-tasks'>
				<hr />
				<h3>Homework Tasks</h3>
				{props.tasksList.length === 0 && <TasksHeader />}
				<button className='teachers-button teachers-button-default' onClick={createTaskClick}>Create Task</button>
				<hr />
				{props.tasksList.length > 0 && <h3>Your tasks</h3>}
				<ul id='teachers-tasks-list'>{myTasks}</ul>
				<div className='teachers-taskslist-simple'>
					{mySimpleButtons}
				</div>
				<ConfirmPane
					showConfirm={showConfirmPane}
					confirmClick={deleteConfirmPaneClick}
					confirmMessage={`Delete ${taskToDelete}`} />
			</div>
		);
	}
}

export default TasksList;

const TasksHeader=function(){
	return(
		<>
			<p>{INTRO_TEXT}</p>
			<p>{CHINA_TEXT}</p>
		</>
	);
}

const DeletingMsg=function(){
    return(
        <div>
            <hr />
            <p className="teachers-statusmessage">Deleting task</p>
        </div>
    );
}